import { createTheme } from '@mantine/core'

// Design system grounded in the native app's brand (see TidesNearMe82
// docs/website-design-styleguide.md). Dark mode reuses the app's exact "ocean"
// palette; light mode is a fresh, ocean-derived pairing (there's no light theme
// in the app). Gold #FFD966 is reserved for direction/attention cues only —
// never a general button color.

// Accent blue family, anchored on the app's bright brand blue #157fb4.
const ocean = [
  '#e4f4fb',
  '#c5e6f4',
  '#9bd3ec',
  '#66bce0',
  '#3aa6d4',
  '#1f96c8',
  '#157fb4', // 6 — app "bright" brand blue (light-mode primary)
  '#106a99',
  '#0c557b',
  '#073f5c',
]

// Dark-mode surfaces/text, mapped to the app navies so dark mode IS the app:
// body #062534, cards #0a405a, borders #0c4967, muted #5b8ba0, text near-white.
const dark = [
  '#e7f0f4', // 0 — primary text
  '#c4d7e0',
  '#8bb8d0', // 2 — muted caption (dimmed text in dark)
  '#5b8ba0', // 3 — secondary text
  '#0c4967', // 4 — borders / panels
  '#0e5074',
  '#0a405a', // 6 — card / surface bg
  '#062534', // 7 — body background (signature navy)
  '#05202d',
  '#041822',
]

// Signal gold — used sparingly for direction/now/attention.
const gold = [
  '#fff8e1',
  '#ffefc0',
  '#ffe49a',
  '#ffd966', // 3 — THE accent
  '#ffce4d',
  '#ffc733',
  '#ffbf1a',
  '#f0ac00',
  '#d69800',
  '#bd8400',
]

export const theme = createTheme({
  primaryColor: 'ocean',
  primaryShade: { light: 6, dark: 4 }, // brighter accent on dark backgrounds
  colors: { ocean, dark, gold },
  // Lato is the production brand typeface (self-hosted; see layouts/_lato.html.erb).
  // Only 400 and 700 are shipped, so fw={500}/fw={600} resolve to those two.
  // 'Lato Fallback' (Arial, absent on Android) then 'Lato Fallback Android'
  // (Roboto): metrics-matched pre-render faces so the swap to Lato moves
  // nothing. Defined in app/views/layouts/_lato.html.erb, with the measurement
  // story. They must sit BEFORE the system families, or the browser never
  // reaches them and the shift comes back.
  fontFamily:
    'Lato, "Lato Fallback", "Lato Fallback Android", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
  headings: {
    fontFamily: 'Lato, "Lato Fallback", "Lato Fallback Android", sans-serif',
    fontWeight: '700',
  },
  defaultRadius: 'md',
})
